// src/contexts/UserContext.js
import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import { getUserInfo, updateUserProfile } from '../api';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true); // Começar como true para indicar carregamento inicial
  const [errorUser, setErrorUser] = useState(null);

  const fetchUserInfo = useCallback(async () => {
    // Não é mais necessário setar setLoadingUser(true) aqui se SessionManager já faz isso
    // ou se o loadingUser inicial já é true.
    try {
      const userData = await getUserInfo();
      setUser(userData);
      setErrorUser(null);
    } catch (error) {
      console.error("Erro ao buscar informações do usuário no UserContext:", error);
      setErrorUser(error);
      setUser(null);
    } finally {
      setLoadingUser(false); // Finaliza o carregamento
    }
  }, []); // Removido setUser e outras dependências que não mudam a função em si

  const updatePreferences = useCallback(async (preferencesToUpdate) => {
    if (!user) return Promise.reject(new Error("User not available"));
    try {
      const updatedUserData = await updateUserProfile(preferencesToUpdate);
      setUser(updatedUserData); // Atualiza o objeto user global

      return updatedUserData;
    } catch (error) {
      console.error("Erro ao atualizar preferências do usuário no UserContext:", error);
      throw error;
    }
  }, [user, setUser]); // setUser é dependência pois é usado para atualizar o estado do usuário

  // O valor de autosave é derivado diretamente do objeto user
  const autosaveEnabled = user ? user.autosave_consultation_drafts : true;

  return (
    <UserContext.Provider value={{ user, setUser, loadingUser, errorUser, fetchUserInfo, updatePreferences, autosaveEnabled }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);